import * as React from 'react';
import * as Sentry from '@sentry/react';
import clsx from 'clsx';
import { useTranslation } from 'common/i18n/hooks';
import { WarningReact } from '../warning';
import { WarningTheme } from '../warning/constants';
import style from './index.module.styl';
type FallbackProps = {
  className?: string;
  fullScreen?: boolean;
  minimal?: boolean;
};
function Fallback(_ref: FallbackProps) {
  let {
    fullScreen,
    minimal,
    className
  }: FallbackProps = _ref;
  const {
    t
  } = useTranslation();
  return <WarningReact {...{
    theme: WarningTheme.Error,
    headerText: minimal ? undefined : t("error-boundary.header"),
    bodyText: minimal ? t("error-boundary.body-minimal") : t("error-boundary.body"),
    small: minimal,
    className: clsx(style.fillContainer, {
      [style.fullScreen]: fullScreen
    }, className)
  }} data-sentry-element="WarningReact" data-sentry-component="Fallback" data-sentry-source-file="index.tsx" />;
}
type ReactErrorBoundaryProps = React.PropsWithChildren & {
  className?: string;
  fallback?: (error: any) => React.ReactNode;
  fullScreen?: boolean;
  minimal?: boolean;
  errorType?: string;
};
export function ReactErrorBoundary(props: ReactErrorBoundaryProps) {
  const fallback = <Fallback fullScreen={props.fullScreen} minimal={props.minimal} className={props.className} />;
  return <Sentry.ErrorBoundary fallback={fallback} data-sentry-element="unknown" data-sentry-component="ReactErrorBoundary" data-sentry-source-file="index.tsx">{props.children}</Sentry.ErrorBoundary>;
}